// Shared constants for the Evaluation System

export const MODELS = {
  openai: [
    { id: 'gpt-5-2025-08-07', name: 'GPT-5', defaultTokens: 128000 },
    { id: 'gpt-5.1-2025-11-13', name: 'GPT-5.1', defaultTokens: 128000 },
    { id: 'gpt-5-nano-2025-08-07', name: 'GPT-5 Nano', defaultTokens: 128000 },
    { id: 'gpt-4o-2024-08-06', name: 'GPT-4o', defaultTokens: 16384 },
    { id: 'gpt-5.2-2025-12-11', name: 'GPT-5.2', defaultTokens: 128000 },
  ],
  anthropic: [
    {
      id: 'claude-sonnet-4-5-20250929',
      name: 'Claude Sonnet 4.5',
      defaultTokens: 32000,
    },
    {
      id: 'claude-sonnet-4-20250514',
      name: 'Claude Sonnet 4',
      defaultTokens: 32000,
    },
    {
      id: 'claude-opus-4-1-20250805',
      name: 'Claude Opus 4',
      defaultTokens: 32000,
    },
  ],
} as const;

export const DEFAULTS = {
  // Execution defaults
  concurrency: 3,
  temperature: 0.7,

  // Pagination defaults
  resultsLimit: 100,
  resultsOffset: 0,

  // UI defaults
  modalMaxWidth: '600px',
  tablePageSize: 50,
} as const;

export const STATUS_COLORS = {
  success: '#10b981',
  error: '#ef4444',
  warning: '#f59e0b',
  muted: '#A8988A',
} as const;

export const STATUS_ICONS = {
  success: '✓',
  error: '✗',
  warning: '⚠️',
  pending: '—',
} as const;

export const RESULT_STATUS_FILTERS = [
  { value: 'all', label: 'All Results' },
  { value: 'valid', label: 'Valid JSON' },
  { value: 'failed', label: 'Failed' },
  { value: 'errors', label: 'Computation Errors' },
] as const;

export const GROUP_BY_OPTIONS = [
  { value: 'none', label: 'No Grouping' },
  { value: 'prompt', label: 'Group by Prompt' },
  { value: 'config', label: 'Group by Config' },
  { value: 'run', label: 'Group by Eval Run' },
] as const;

// ==================== VOTING CONFIGURATION ====================

/**
 * Minimum number of valid models required to enable voting
 * Used by both OpenArena and Seed Rankings
 */
export const MIN_VALID_MODELS_FOR_VOTING = 3;

/**
 * Target number of pairwise matches per prompt in Seed Rankings
 */
export const TARGET_MATCHES_PER_PROMPT = 7;

/**
 * Target number of pairwise matches per OpenArena run
 * Keep at 4 to maintain current UX
 */
export const TARGET_MATCHES_PER_ARENA = 4;

/**
 * Valid vote choices for pairwise comparisons
 */
export const VOTE_CHOICES = ['a', 'b', 'tie', 'both_bad'] as const;

// ==================== LEADERBOARD CONFIGURATION ====================

/**
 * Minimum number of battles before a model's rating is considered stable.
 * Models with fewer battles will appear in the "Pending More Battles" section.
 */
export const MIN_MATCHES_FOR_RANKING = 50;
